
import React, { Component } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import { connect } from "react-redux";
import Moment from "react-moment";
import { ToastContainer, toast } from "react-toastify";
import { roleMasterActions, userMasterActions } from "../../actions";
import tableRequest from "../../models/tableRequest";
import Switch from "@mui/material/Switch";
import { Calendar } from "primereact/calendar";
import { CSVLink } from "react-csv";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import ListItemText from '@mui/material/ListItemText';

class userMaster extends Component {
  constructor(props) {
    super(props);
    this.csvLink = React.createRef();
    this.tblResponse = new tableRequest();
    this.state = {
      GSBPhoto: null,
      GSBPhotoPreview: "",
      formError: {
        GSBPhoto: "",
        UserName: "",
        UserTypeId: "",
        // UserTypeId:rowData?.UserType ?? 3,
        DealerTypeId: "",
        SellingXPProductId: "",
        City: "",
        MarketPlace: "",
        MarketType: "",
        CounterName: "",
        OwnerName: "",
        LinkedPrimaryDealerName: "",
        BusinessPotentialPerMonth: "",
        DealerGradeId: "",
        Email: "",
        DealerMobileNo: "",
        Password: "",
        ConfirmPassword: "",
        RoleId: "",
        WareHouseId: "",
        State: "",
        District: "",
      },
      //Region: "",
      //RegionLabel: "",
      Region:[],
      RegionLabel:[],
      regionList: [],

      SalesPerson: "",
      SalesPersonLabel: "",
      salespersonList: [],

      State: [],
      DealerGradeId: "",
      FromDate: new Date(),
      ToDate: new Date(),
      formError: {},
      IsAdd: true,
      IsEdit: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      sortOrder: "",
      buttonLabel: "Submit",
      switchAction: false,
      formHeading: "Add User Master",
      UserId: 0,    
      RoleId: 0,
      RoleName: "",
      UserTypeId: "",
      UserTypeData: [
        { value: 1, label: "Web" },
        { value: 2, label: "Mobile" },
        { value: 4, label: "Warehouse" },
      ],
      DealerTypeId: "",
      DealerTypeData: [
        { value: 1, label: "Primary Dealer" },
        { value: 2, label: "Sub Dealer" },
        { value: 3, label: "End User" },
      ],
      SellingXPProductId: "",
      SellingXPProductData: [
        { value: 1, label: "Yes" },
        { value: 2, label: "No" },
      ],
      UserName: "",
      Email: "",
      //City: "",
      showCityDropdown: false, // initially hidden
      City:[],
      MarketPlace: "",
      MarketType: "",
      CounterName: "",
      OwnerName: "",
      LinkedPrimaryDealerName: "",
      BusinessPotentialPerMonth: "",
      DealerMobileNo: "",
      Password: "",
      ConfirmPassword: "",
      IsActive: true,
      CreatedDate: null,
      UpdatedDate: null,
      WareHouseId: "",
      District: [],
      CompanyId: 1, // Default value, adjust as needed
      CreatedBy: 0, // Will be set based on logged-in user
      UpdatedByUser: 0, // Will be set based on logged-in user
      SaltPassword: "", // Will be handled as needed
    };

    // Bind methods
    this.statusBodyTemplate = this.statusBodyTemplate.bind(this);
    this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    this.switchToggleConfirm = this.switchToggleConfirm.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.exportCSVAll = this.exportCSVAll.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleWChange = this.handleWChange.bind(this);
    this.handleSChange = this.handleSChange.bind(this);
    this.handleRChange = this.handleRChange.bind(this);
    this.handleASMChange = this.handleASMChange.bind(this);
    this.handleGChange = this.handleGChange.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.CreatedDateTemplate = this.CreatedDateTemplate.bind(this);
    this.UpdatedDateTemplate = this.UpdatedDateTemplate.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.onHide = this.onHide.bind(this);
    this.getRList = this.getRList.bind(this);
    this.getRoleList = this.getRoleList.bind(this);
    this.getSList = this.getSList.bind(this);
    this.getGList = this.getGList.bind(this);
    this.getDistrictList = this.getDistrictList.bind(this);
    this.getCityList = this.getCityList.bind(this);
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleCityChange =this.handleCityChange .bind(this);

  }
  handleShowCity = () => {
  this.setState({ showCityDropdown: true });
};
  componentDidMount() {
    ;
    this.props.getRDDL();
    this.props.getASMDDL();

    // Date Setup
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() - 7);

    this.tblResponse.FromDate = date.toLocaleDateString("en-US", {
      year: "numeric", month: "2-digit", day: "2-digit"
    });

    this.tblResponse.ToDate = new Date().toLocaleDateString("en-US", {
      year: "numeric", month: "2-digit", day: "2-digit"
    });

    this.setState({ FromDate: date, ToDate: new Date() });

    // Get permissions
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const pageName = window.location.pathname.split("/").pop();
      const obj = assignedPermissions.assigned.find(x => x.ActionName === pageName);
      if (obj) {
        this.setState({ IsEdit: !!obj.IsEdit, IsAdd: !!obj.IsAdd });
      }
    }

    // ✅ Get user from correct key
    const userData = JSON.parse(sessionStorage.getItem("user")); // <- correct key
    console.log("userData:", userData);
    if (userData && userData.RegionId) {
      debugger
      ;
      //const regionId = userData.RegionId ? Number(userData.RegionId) : null;
         const regionId = userData.RegionId 
         ? userData.RegionId.split(",").map(id => Number(id.trim()))
         : [];
        console.log("regionIds:", regionId);
       this.setState({
        CreatedBy: userData.UserId || 0,
        UpdatedByUser: userData.UserId || 0
      });

      if (regionId) {
        this.props.getSDDL(regionId || 0 );       
      }
    }     
    // Other API calls
    this.props.getWDDL(this.tblResponse);
    this.props.getGDDL(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  componentDidUpdate(prevProps) {
    if (this.props.UserData) {
      if (prevProps.UserData !== this.props.UserData) {
        // this.props.myProp has a different value
        if (this.props.UserData) {
          var e = this.props.UserData;
          this.setState({
            totalRecords: e[0].TotalRows
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0
        });
    }

  }

  switchToggleConfirm = () => {
    this.props.inActiveRow(this.state.UserId, this.state.switchAction);
  };

  FilterData() {
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    this.props.fetchApi(this.tblResponse);
  }

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Store the actual File object for upload
      this.setState({
        GSBPhoto: file, // <-- this is the raw file used in FormData
        formError: {
          ...this.state.formError,
          GSBPhoto: "",
        },
      });

      // Generate preview base64 string only for showing preview
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          GSBPhotoPreview: reader.result, // <-- this is base64 just for preview
        });
      };
      reader.readAsDataURL(file);
    }
  };


  handleChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    if (name === "IsActive") {
      value = event.target.checked;
    }

    this.validateForm(value, name);

    if (name === "RoleId") {
      const selectedRole = this.props.UserRoleData?.find(
        (x) => x.value === value.toString()
      );
      this.setState({ RoleName: selectedRole ? selectedRole.label : "" });
    }

    this.setState({ formError: errors, [name]: value });
  }

  handleToggleChange = (e) => {
    this.setState({ useManualEntry: e.target.value === "manual", LinkedPrimaryDealerName: "" });
  };

  handleWChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    if (name === "IsActive") {
      value = event.target.checked;
    }
    this.validateForm(value, name);
    this.setState({ formError: errors, [name]: value });
  }

  handleSChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    if (name === "IsActive") {
      value = event.target.checked;
    }
    this.validateForm(value, name);
    this.setState({ formError: errors, [name]: value });
  }
  // handleRChange = (event) => {
  //   const selectedValue = event.target.value;
  //   // const matchedItem = this.props.UserRData.find(
  //   //   (item) => item.value === selectedValue
  //   // );
  //   const matchedItem = this.props.UserRData.filter((item) =>
  //   selectedValue.includes(item.value)
  // );

  //   this.setState({
  //     Region: selectedValue,
  //     //RegionLabel: matchedItem?.label || "",
  //     RegionLabel:matchedItem.map((m) => m.label).join(", "),
  //   });
  // };
handleRChange = (event) => {
  let { value } = event.target;

  // Normalize to array of strings
  if (typeof value === "string") {
    value = value.split(",");
  }
  value = value.map(String); // force all to string

  const regionData = this.props.UserRData || [];
  const matchedItems = regionData.filter((item) =>
    value.includes(String(item.value))
  );

  this.setState({
    Region: value, // array of string ids
    RegionLabel: matchedItems.map((m) => m.label).join(", "),
  });
};



  handleASMChange = (event) => {

    const selectedValue = event.target.value;
    const matchedItem = this.props.UserASMData.find(
      (item) => item.value === selectedValue
    );

    this.setState({
      SalesPerson: selectedValue,
      SalesPersonLabel: matchedItem?.label || "",
    });
  };


  handleGChange(event) {
    let { name, value } = event.target;
    let errors = this.state.formError;
    this.validateForm(value, name);
    this.setState({ formError: errors, [name]: value });
  }

  handleChangeDate(event) {
    const { name, value } = event.target;
    switch (name) {
      case "FromDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select from date.");
          return;
        } else if (
          !value
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
            .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date.");
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("From date must be less than to date.");
            return;
          }
        }
        break;
      case "ToDate":
        if (value === null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select to date.");
          return;
        } else if (
          !value
            .toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit"
            })
            .match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date.");
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("To date must be greater than from date.");
            return;
          }
        }
        break;
      default:
        break;
    }
    this.setState({ [name]: value });
  }


  getRoleList(event) {

    this.setState({ UserTypeId: event.target.value });
    this.props.getRoleDDL(event.target.value);
  }

  getSList(event) {
    this.setState({ State: event.target.value });
    this.props.getSDDL(event.target.value);
  }

  getRList(event) {
    ;
    this.setState({ State: event.target.value });
    this.props.getRDDL(event.target.value);
  }
  getASMList(event) {

    this.setState({ State: event.target.value });
    this.props.getASMDDL(event.target.value);
  }

  getGList(event) {
    this.setState({ DealerGradeId: event.target.value });
    this.props.getGDDL(event.target.value);
  }
  getDistrictList(event) {

    const selectedState = event.target.value;
    this.setState({ State: selectedState });
    this.props.getDistrictDDL(selectedState);
  }
handleCityClick = () => {
  this.setState((prev) => ({ cityClickCount: prev.cityClickCount + 1 }));
};

handleCityChange = (event) => {
  const value = event.target.value;

  if (value.includes("ALL")) {
    // Select/Deselect all
    this.setState({
      City:
        this.state.City.length === (this.props.UserCityData?.length || 0)
          ? []
          : (this.props.UserCityData || []).map((c) => String(c.value)),
    });
  } else {
    this.setState({ City: value });
  }
};


  getCityList = (event) => {

    const selectedDistrict = event.target.value;

    this.setState({
      District: selectedDistrict,
      //City: '' // Clear city when district changes
      City:[]
    });

    this.props.getCityDDL(selectedDistrict); // async Redux call
  };

// getCityList = (event) => {
//   let { value } = event.target;
//   if (!Array.isArray(value)) value = [value];

//   const districtData = this.props.UserDistrictData || [];
//   const allIds = districtData.map(d => String(d.value));

//   // If user clicked "Select All"
//   if (value.includes("all")) {
//     const isAllSelected = this.state.District?.length === allIds.length;
//     value = isAllSelected ? [] : allIds;
//   }

//   const matchedItems = districtData.filter(d => value.includes(String(d.value)));

//   this.setState({
//     District: value,
//     DistrictLabel: matchedItems.map(d => d.label).join(", "),
//   });
// };


  UpdatedDateTemplate(rowData) {
    if (rowData.UpdatedDate) {
      return <Moment format="D MMM YYYY">{rowData.UpdatedDate}</Moment>;
    }
    return null;
  }

  CreatedDateTemplate(rowData) {
    if (rowData.CreatedDate) {
      return <Moment format="D MMM YYYY">{rowData.CreatedDate}</Moment>;
    }
    return null;
  }

  validateAllFields = () => {
  const errors = {};
  const state = this.state;
  const isDealer = state.RoleName === "Dealer";

  // Common validations for all roles
  if (!state.UserName) errors.UserName = "Please enter username.";
  if (!state.UserTypeId) errors.UserTypeId = "Please select user type.";
  if (!state.RoleId) errors.RoleId = "Please select user role.";
  
  if (!state.Email) {
    errors.Email = "Please enter email.";
  } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(state.Email)) {
    errors.Email = "Please enter valid email.";
  }

  if (!state.DealerMobileNo) {
    errors.DealerMobileNo = "Please enter mobile number.";
  } else if (!/^[6-9]\d{9}$/.test(state.DealerMobileNo)) {
    errors.DealerMobileNo = "Please enter valid mobile number.";
  }

  if (!state.Password || state.Password.length < 4) {
    errors.Password = "Password should be minimum 4 characters long.";
  }

  if (state.Password !== state.ConfirmPassword) {
    errors.ConfirmPassword = "Passwords do not match.";
  }

  // Dealer-specific validations
  if (isDealer) {
    if (!state.State) errors.State = "Please select state.";
    if (!state.District) errors.District = "Please select district.";
    if (!state.City) errors.City = "Please enter city.";
    if (!state.MarketPlace) errors.MarketPlace = "Please enter market place.";
    if (!state.MarketType) errors.MarketType = "Please enter market type.";
    if (!state.CounterName) errors.CounterName = "Please enter counter name.";
    if (!state.DealerTypeId) errors.DealerTypeId = "Please select dealer type.";
    if (!state.OwnerName) errors.OwnerName = "Please enter owner name.";
    if (!state.LinkedPrimaryDealerName) errors.LinkedPrimaryDealerName = "Please enter primary dealer name.";
    if (!state.BusinessPotentialPerMonth) {
      errors.BusinessPotentialPerMonth = "Please enter business potential.";
    } else if (isNaN(state.BusinessPotentialPerMonth) || state.BusinessPotentialPerMonth <= 0) {
      errors.BusinessPotentialPerMonth = "Please enter a valid amount.";
    }
    if (!state.DealerGradeId) errors.DealerGradeId = "Please select dealer grade.";
    if (!state.SellingXPProductId) errors.SellingXPProductId = "Please select selling XP product.";
    if (!state.GSBPhoto) errors.GSBPhoto = "Please upload a picture.";
    if (!state.SalesPerson) errors.SalesPerson = "Please select sales person.";
  } 
  // RSM validation
  else if (state.RoleName === "RSM") {
    if (!state.Region) errors.Region = "Please select region.";
  }
  // Other roles validation
  else if (["ASM", "Customer", "Sales Coordinator", "Sales Person", "Accounts Department", "Logistics Department"].includes(state.RoleName)) {
    if (!state.State) errors.State = "Please select state.";
    if (!state.District) errors.District = "Please select district.";
    if (!state.City) errors.City = "Please select city.";
  }

  return errors;
};



  validateForm(value, name) {
   
    let errors = { ...this.state.formError };
    let isValid = true;

    if (this.state.RoleName === "Dealer") {
      switch (name) {
        case "UserName":
          if (!value) {
            isValid = false;
            errors.UserName = "Please enter username.";
          } else {
            errors.UserName = "";
          }
          break;
        case "UserTypeId":
          if (!value) {
            isValid = false;
            errors.UserTypeId = "Please select user type.";
          } else {
            errors.UserTypeId = "";
          }
          break;
        case "DealerTypeId":
          if (!value) {
            isValid = false;
            errors.DealerTypeId = "Please select dealer type.";
          } else {
            errors.DealerTypeId = "";
          }
          break;
        case "SellingXPProductId":
          if (!value) {
            isValid = false;
            errors.SellingXPProductId = "Please select selling XP product.";
          } else {
            errors.SellingXPProductId = "";
          }
          break;
        case "RoleId":
          if (!value) {
            isValid = false;
            errors.RoleId = "Please select user role.";
          } else {
            errors.RoleId = "";
          }
          break;
        case "WareHouseId":
          if (!value) {
            isValid = false;
            errors.WareHouseId = "Please select warehouse.";
          } else {
            errors.WareHouseId = "";
          }
          break;
        case "State":
          if (!value) {
            isValid = false;
            errors.State = "Please select state.";
          } else {
            errors.State = "";
          }
          break;
        case "District":
          if (!value) {
            isValid = false;
            errors.District = "Please select district.";
          } else {
            errors.District = "";
          }
          break;
        case "City":
          if (!value) {
            isValid = false;
            errors.City = "Please enter city.";
          } else {
            errors.City = "";
          }
          break;
        case "MarketPlace":
          if (!value) {
            isValid = false;
            errors.MarketPlace = "Please enter market place.";
          } else {
            errors.MarketPlace = "";
          }
          break;
        case "MarketType":
          if (!value) {
            isValid = false;
            errors.MarketType = "Please enter market type.";
          } else {
            errors.MarketType = "";
          }
          break;
        case "CounterName":
          if (!value) {
            isValid = false;
            errors.CounterName = "Please enter counter name.";
          } else {
            errors.CounterName = "";
          }
          break;
        case "OwnerName":
          if (!value) {
            isValid = false;
            errors.OwnerName = "Please enter owner name.";
          } else {
            errors.OwnerName = "";
          }
          break;
        case "LinkedPrimaryDealerName":
          if (!value) {
            isValid = false;
            errors.LinkedPrimaryDealerName = "Please enter primary dealer name.";
          } else {
            errors.LinkedPrimaryDealerName = "";
          }
          break;
        case "BusinessPotentialPerMonth":
          if (!value) {
            isValid = false;
            errors.BusinessPotentialPerMonth = "Please enter business potential.";
          } else if (isNaN(value) || value <= 0) {
            isValid = false;
            errors.BusinessPotentialPerMonth = "Please enter a valid amount.";
          } else {
            errors.BusinessPotentialPerMonth = "";
          }
          break;
        case "DealerGradeId":
          if (!value) {
            isValid = false;
            errors.DealerGradeId = "Please select dealer grade.";
          } else {
            errors.DealerGradeId = "";
          }
          break;
        case "Email":
          if (!value) {
            isValid = false;
            errors.Email = "Please enter email.";
          } else if (
            !value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
          ) {
            isValid = false;
            errors.Email = "Please enter valid email.";
          } else {
            errors.Email = "";
          }
          break;
        case "DealerMobileNo":
          if (!value) {
            isValid = false;
            errors.DealerMobileNo = "Please enter mobile number.";
          } else if (!value.match(/^[6-9]\d{9}$/)) {
            isValid = false;
            errors.DealerMobileNo = "Please enter valid mobile number.";
          } else {
            errors.DealerMobileNo = "";
          }
          break;
        case "Password":
          if (!value || value.length < 4) {
            isValid = false;
            errors.Password = "Password should be minimum 4 characters long.";
          } else {
            errors.Password = "";
          }
          break;
        case "ConfirmPassword":
          if (value !== this.state.Password) {
            isValid = false;
            errors.ConfirmPassword = "Passwords do not match.";
          } else {
            errors.ConfirmPassword = "";
          }
          break;
        case "GSBPhoto":
          if (!this.state.GSBPhoto) {
            isValid = false;
            errors.GSBPhoto = "Please upload a picture.";
          } else {
            errors.GSBPhoto = "";
          }
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case "UserName":
          if (!value) {
            isValid = false;
            errors.UserName = "Please enter username.";
          } else {
            errors.UserName = "";
          }
          break;
        case "UserTypeId":
          if (!value) {
            isValid = false;
            errors.UserTypeId = "Please select user type.";
          } else {
            errors.UserTypeId = "";
          }
          break;
        case "RoleId":
          if (!value) {
            isValid = false;
            errors.RoleId = "Please select user role.";
          } else {
            errors.RoleId = "";
          }
          break;
        case "Email":
          if (!value) {
            isValid = false;
            errors.Email = "Please enter email.";
          } else if (
            !value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
          ) {
            isValid = false;
            errors.Email = "Please enter valid email.";
          } else {
            errors.Email = "";
          }
          break;
        case "DealerMobileNo":
          if (!value) {
            isValid = false;
            errors.DealerMobileNo = "Please enter mobile number.";
          } else if (!value.match(/^[6-9]\d{9}$/)) {
            isValid = false;
            errors.DealerMobileNo = "Please enter valid mobile number.";
          } else {
            errors.DealerMobileNo = "";
          }
          break;
        case "Password":
          if (!value || value.length < 4) {
            isValid = false;
            errors.Password = "Password should be minimum 4 characters long.";
          } else {
            errors.Password = "";
          }
          break;
        case "ConfirmPassword":
          if (value !== this.state.Password) {
            isValid = false;
            errors.ConfirmPassword = "Passwords do not match.";
          } else {
            errors.ConfirmPassword = "";
          }
          break;
        default:
          break;
      }
    }

    this.setState({ formError: errors });
    return isValid;
  }

  getDropValueOfRole() {
    return this.props.UserRoleData?.find(
      (x) => x.value === this.state.RoleId.toString()
    )?.label || "";
  }

  getDropValueOfW() {
    return this.props.UserWData?.find(
      (x) => x.value === this.state.WareHouseId.toString()
    )?.label || "";
  }

  // getDropValueOfState = () => {
  //   debugger;
  //   const state = this.props.UserSData?.find(
  //     (x) => x.value === this.state.State
  //   );
  //   return state ? state.label : "";
  // };
     getDropValueOfState=()=>{
      const { State } = this.state;

      if (!Array.isArray(State) || State.length === 0) return "";
      const labels = State.map(val =>
    this.props.UserSData.find(x => x.value === val)?.label
  ).filter(Boolean); // remove undefineds if mismatch

  return labels.join(", ");
     }

  // getDropValueOfRegion = () => {

  //   const selected = this.props.UserRData?.find(
  //     (x) => x.value === this.state.Region.toString()
  //   );
  //   return selected ? selected.label : "";
  // };
  getDropValueOfRegion = () => {
  const { Region } = this.state;

  if (!Array.isArray(Region) || Region.length === 0) return "";

  const labels = Region.map(val =>
    this.props.UserRData.find(x => x.value === val)?.label
  ).filter(Boolean); // remove undefineds if mismatch

  return labels.join(", ");
};

 getValueFromRegionLabel= () =>{
  const{RegionId}= this.state;

  if(!Array.isArray(RegionId)|| RegionId.length===0) return "";

  const values= RegionId.map(val=> this.props.UserRData.find(x=>x.label=== val)?.value).filter(Boolean)
  return values.join(",");
  

 };

  getDropValueOfSalesPerson = () => {

    const selected = this.props.UserASMData?.find(
      (x) => x.value === this.state.SalesPerson.toString()
    );
    return selected ? selected.label : "";
  };

//   getValueFromRegionLabel1 = () => {
//   if (!labels) return [];

//   // Ensure labels is always an array
//   const labelArray = Array.isArray(labels) ? labels : [labels];

//   const values = labelArray.map(label => {
//     if (typeof label !== "string") {
//       console.warn("Label is not a string:", label);
//       return null;
//     }

//     const match = this.props.UserRData?.find(
//       (item) =>
//         typeof item.label === "string" &&
//         item.label.trim().toLowerCase() === label.trim().toLowerCase()
//     );

//     return match ? match.value : null;
//   }).filter(Boolean); // remove nulls

//   return values;
// };



//   getValueFromRegionLabel = (label) => {
//   console.log("Looking for label:", label);
//   console.log("UserRData:", this.props.UserRData);

//   const searchLabel = (label ?? "").toString().trim().toLowerCase();

//   const match = this.props.UserRData?.find((item) => {
//     const itemLabel = (item.label ?? "").toString().trim().toLowerCase();
//     return itemLabel === searchLabel;
//   });

//   console.log("Match found:", match);

//   return match ? match.value : "";
// };


  getValueFromASMLabel = (label) => {
    console.log("Looking for label:", label);
    console.log("UserASMData:", this.props.UserASMData);

    const match = this.props.UserASMData?.find(
      (item) => item.label?.trim().toLowerCase() === label?.trim().toLowerCase()
    );

    console.log("Match found:", match);

    return match ? match.value : "";
  };

  getValueFromStateLabel = (label) => {
    ;
    console.log("Looking for label:", label);
    console.log("UserRData:", this.props.Wdd2);

    const match = this.props.UserSData?.find(
      (item) => item.label?.trim().toLowerCase() === label?.trim().toLowerCase()
    );
  
    console.log("Match found:", match);
  
    return match ? match.value : "";
  };

  getDropValueOfDistrict() {
    return this.props.UserDistrictData?.find(
      (x) => x.value === this.state.District.toString()
    )?.label || "";
  }

  getDropValueOfCity() {
    ;
    return this.props.UserCityData?.find(
      (x) => x.value === this.state.City.toString()
    )?.label || "";
  }

  getDropValueOfDealerGrade() {
    return this.props.DealerGData?.find(
      (x) => x.value === this.state.DealerGradeId.toString()
    )?.label || "";
  }

  getDropValueOfUserType() {
    debugger
    return this.state.UserTypeData.find(
      (x) => x.value === this.state.UserTypeId
    )?.label || "";
  }

  // getDropValueOfSellingXPProduct() {
  //   
  //   var data = this.state.SellingXPProductData.find(
  //     (x) => x.value === this.state.SellingXPProductId
  //   )?.label === "Yes";

  //   return data;
  // }

  getDropValueOfSellingXPProduct() {
    const item = this.state.SellingXPProductData.find(
      (x) => x.value === this.state.SellingXPProductId
    );
    return item ? item.label : "";
  }

  submitForm(event) {
    debugger;
  event.preventDefault();
  
  // Validate all fields at once
  const errors = this.validateAllFields();
  const hasErrors = Object.values(errors).some(error => error !== "");
   
  if (hasErrors) {
    this.setState({ 
      formError: errors,
      isSubmitting: false
    });
    return;
  }

  this.setState({ isSubmitting: true });

  const userData = JSON.parse(sessionStorage.getItem("UserData")) || {};
  const userId = userData.UserId || 0;
  const userName = userData.UserName || "";

  if (this.state.RoleName === "Dealer") {
    const user = JSON.parse(sessionStorage.getItem("user")) || {};
    const sessionRegionId = user.RegionId || null;

    const formData = new FormData();
    // Append all dealer fields
    formData.append("RegionId", sessionRegionId);
    formData.append("RMSId", userId);
    formData.append("State", this.state.State);
    formData.append("District", this.state.District);
    formData.append("SalespersonId", this.state.SalesPerson);
    formData.append("CityLocation", this.state.City);
    formData.append("MarketPlace", this.state.MarketPlace);
    formData.append("MarketType", this.state.MarketType);
    formData.append("DealerMobileNo", this.state.DealerMobileNo);
    formData.append("CounterName", this.state.CounterName);
    
    const dealerType = this.state.DealerTypeData.find(
      x => x.value === this.state.DealerTypeId
    );
    formData.append("DealerType", dealerType ? dealerType.label : "");
    
    formData.append("UserType", this.state.UserTypeId);
    formData.append("OwnerName", this.state.OwnerName);
    formData.append("UserName", this.state.UserName);
    formData.append("EmailId", this.state.Email);
    formData.append("LinkedPrimaryDealerName", this.state.LinkedPrimaryDealerName);
    formData.append("BusinessPotentialPerMonth", this.state.BusinessPotentialPerMonth);
    
    const dealerGrade = this.props.DealerGData.find(
      g => g.value === this.state.DealerGradeId
    );
    formData.append("DealerGrade", dealerGrade ? dealerGrade.label : "");
    
    const sellingProduct = this.state.SellingXPProductData.find(
      p => p.value === this.state.SellingXPProductId
    );
    formData.append("IsSellingExtraPower", sellingProduct ? sellingProduct.label : "");
    
    formData.append("CreateBy", userName);
    formData.append("UpdatedBy", userName);
    formData.append("UpdatedByUser", userId);
    formData.append("CompanyId", this.state.CompanyId);
    formData.append("WareHouseId", this.state.WareHouseId || 0);
    formData.append("City", this.state.City);
    formData.append("Password", this.state.Password);
    formData.append("SaltPassword", this.state.SaltPassword || "");
    
    if (this.state.GSBPhoto) {
      formData.append("CounterImage", this.state.GSBPhoto);
    }

    // Submit dealer form
    this.props.createUserDetails(formData)    
      .then(() => {
        toast.success("Dealer created successfully!");
        this.resetForm();
        this.props.onHideShow(false);
        // this.tblResponse = new tableRequest();
        this.props.fetchApi(this.tblResponse);
        //window.location.reload();
      })
      .catch(error => {
        console.error("Dealer creation failed:", error);
        toast.error(`Failed to create dealer: ${error.message || "Server error"}`);
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  } else {
    // Non-dealer submission
    const formData = {
      
      UserId: this.state.UserId,
      UserType: this.state.UserTypeId,
      UserTypeName: this.getDropValueOfUserType(),
      RoleId: this.state.RoleId,
      RoleName: this.getDropValueOfRole(),
      UserName: this.state.UserName,
      Email: this.state.Email,
      MobileNo: this.state.DealerMobileNo,
      Password: this.state.Password,
      IsActive: this.state.IsActive,
      CreatedDate: this.state.UserId > 0 
        ? this.state.CreatedDate 
        : new Date().toISOString().split('T')[0],
      UpdatedDate: this.state.UserId > 0 
        ? new Date().toISOString().split('T')[0] 
        : null,
      isApproved: true,
      isDeleted: false
    };

    // Add role-specific fields
    if (this.state.RoleName === "RSM") {
      debugger;
      // formData.Region = this.getDropValueOfRegion();
      
      //formData.RegionId = this.getValueFromRegionLabel(this.state.RegionLabel.label);
       formData.RegionId=this.state.Region.join(",");
       formData.Region = this.getDropValueOfRegion(this.state.Region);
 
        //Check if RegionLabel is a number (e.g. "1", 2)
        if (!isNaN(this.state.Region)) {
          // It's a numeric string or number, use it directly
          formData.RegionId = this.state.Region;
        }
        //  else {
        //   // It's a label like "North", look up the corresponding ID
        //   formData.RegionId = this.getValueFromRegionLabel(this.state.RegionLabel);
        // }
 
    } else if (["ASM", "Customer", "Sales Coordinator", "Sales Person", 
               "Accounts Department", "Logistics Department"].includes(this.state.RoleName)) {
                debugger;
      const user = JSON.parse(sessionStorage.getItem("user")) || {};
      formData.RegionId = user.RegionId;
      //formData.State = this.state.State;
      formData.State = Array.isArray(this.state.State)
  ? this.state.State.join(",")   // e.g. "18,19"
  : this.state.State;
      //formData.DistrictId = this.state.District;
      formData.DistrictId= Array.isArray(this.state.District)
      ? this.state.District.join(",") : this.state.District;      
      formData.StateName = this.getDropValueOfState();
      //formData.City = this.state.City;
      formData.City=Array.isArray(this.state.City)
      ? this.state.City.join(",") : this.state.City;
      
    }
   debugger;
    // Submit non-dealer form
    const submitAction = this.state.UserId > 0
      ? this.props.updateUser(formData)
      : this.props.createUser(formData);
    submitAction    
      .then(() => {
        // toast.success(`User ${this.state.UserId > 0 ? 'updated' : 'created'} successfully!`);
        this.resetForm();        
        this.props.onHideShow(false);
        // this.tblResponse = new tableRequest()
         this.props.fetchApi(this.tblResponse);
       // window.location.reload();        
        // Logout if current user updated their own account
        if (this.state.UserId > 0 && this.state.UserId === userId) {
          setTimeout(() => {
            sessionStorage.clear();
            window.location.href = "/login";
          }, 2000);
        }
      })
      .catch(error => {
        console.error("User operation failed:", error);
       // toast.error(`Failed to ${this.state.UserId > 0 ? 'update' : 'create'} user: ${error.message || "Server error"}`);
      })      
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }
}

  validateAllFields = () => {
  const errors = {};
  const state = this.state;
  const isDealer = state.RoleName === "Dealer";

  // Common validations for all roles
  if (!state.UserName) errors.UserName = "Please enter username.";
  if (!state.UserTypeId) errors.UserTypeId = "Please select user type.";
  if (!state.RoleId) errors.RoleId = "Please select user role.";
  if (!state.Email) {
    errors.Email = "Please enter email.";
  } else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(state.Email)) {
    errors.Email = "Please enter valid email.";
  }

  if (!state.DealerMobileNo) {
    errors.DealerMobileNo = "Please enter mobile number.";
  } else if (!/^[6-9]\d{9}$/.test(state.DealerMobileNo)) {
    errors.DealerMobileNo = "Please enter valid mobile number.";
  }

  if (!state.Password || state.Password.length < 4) {
    errors.Password = "Password should be minimum 4 characters long.";
  }

  if (state.Password !== state.ConfirmPassword) {
    errors.ConfirmPassword = "Passwords do not match.";
  }  
  // Role-specific validations
  if (isDealer) {
    if (!state.State) errors.State = "Please select state.";
    if (!state.District) errors.District = "Please select district.";
    if (!state.City) errors.City = "Please enter city.";
    if (!state.MarketPlace) errors.MarketPlace = "Please enter market place.";
    if (!state.MarketType) errors.MarketType = "Please enter market type.";
    if (!state.CounterName) errors.CounterName = "Please enter counter name.";
    if (!state.DealerTypeId) errors.DealerTypeId = "Please select dealer type.";
    if (!state.OwnerName) errors.OwnerName = "Please enter owner name.";
    if (!state.LinkedPrimaryDealerName) errors.LinkedPrimaryDealerName = "Please enter primary dealer name.";
    
    if (!state.BusinessPotentialPerMonth) {
      errors.BusinessPotentialPerMonth = "Please enter business potential.";
    } else if (isNaN(state.BusinessPotentialPerMonth) || parseFloat(state.BusinessPotentialPerMonth) <= 0) {
      errors.BusinessPotentialPerMonth = "Please enter a valid amount.";
    }    
    if (!state.DealerGradeId) errors.DealerGradeId = "Please select dealer grade.";
    if (!state.SellingXPProductId) errors.SellingXPProductId = "Please select selling XP product.";
    if (state.GSBPshoto) errors.GSBPhoto = "Please upload a picture.";
    if (!state.SalesPerson) errors.SalesPerson = "Please select sales person.";
  } 
  else if (state.RoleName === "RSM") {
    if (!state.Region) errors.Region = "Please select region.";
  }  
  else if (["ASM", "Customer", "Sales Coordinator", "Sales Person", 
            "Accounts Department", "Logistics Department"].includes(state.RoleName)) {
    if (!state.State) errors.State = "Please select state.";
    if (!state.District) errors.District = "Please select district.";
    if (!state.City) errors.City = "Please select city.";
  }

  return errors;
};

  resetForm() {
    this.setState({
      UserId: 0,
      UserTypeId: "",
      UserName: "",
      RoleId: "",
      RoleName: "",
      WareHouseId: "",
      DealerTypeId: "",
      SellingXPProductId: "",
      City: [],
      MarketPlace: "",
      MarketType: "",
      CounterName: "",
      OwnerName: "",
      LinkedPrimaryDealerName: "",
      BusinessPotentialPerMonth: "",
      DealerGradeId: "",
      State: [],
      District: [],
      Email: "",
      DealerMobileNo: "",
      Password: "",
      ConfirmPassword: "",
      IsActive: true,
      GSBPhoto: null,
      GSBPhotoPreview: "",
      SaltPassword: "",
      isSubmitting: false,
      formError: {
        UserName: "",
        UserTypeId: "",
        DealerTypeId: "",
        SellingXPProductId: "",
        City: "",
        MarketPlace: "",
        MarketType: "",
        CounterName: "",
        OwnerName: "",
        LinkedPrimaryDealerName: "",
        BusinessPotentialPerMonth: "",
        DealerGradeId: "",
        Email: "",
        DealerMobileNo: "",
        Password: "",
        ConfirmPassword: "",
        RoleId: "",
        WareHouseId: "",
        State: "",
        District: "",
        GSBPhoto: "",
      },
    });
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    //this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    let searchValue = "";
    if (event.globalFilter) {
      searchValue = event.globalFilter;
    } else if (event.filters) {
      const filterValues = Object.values(event.filters)
        .map(f => f?.value)
        .filter(v => v);
      searchValue = filterValues.join(" ");
    }
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
 
  onPage(event) {                        
    this.props.loadingData(true);

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.props.fetchApi(this.tblResponse);
    }, 250);
  }
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0]?.field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0]?.field || "";
    this.tblResponse.SortColumn = sortField;
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.props.fetchApi(this.tblResponse);
  }

  onHide() {
    this.props.onHideShow(false);
    this.resetForm();
  }

  openDialog() {
    this.props.onHideShow(true);
    this.setState({ buttonLabel: "Submit", formHeading: "Add User" });
  }

  statusBodyTemplate(rowData) {
    if (rowData) {
      return (
        <Checkbox
          disabled
          checked={rowData.IsActive}
          color="primary"
          inputProps={{ "aria-label": "secondary checkbox" }}
        />
      );
    }
    return null;
  }

  getCurrentDateMMDDYYY() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  actionBodyTemplate(rowData) {
    console.log("rowData", rowData);

    // const editMode = async () => {
    //   debugger;
    //   const userRole = JSON.parse(sessionStorage.getItem("UserRole"));

    //   try {
    //     if (
    //       String(userRole) === "1" &&
    //       (rowData.RoleName === "Dealer" || rowData.RoleName === "ASM")
    //     ) {
    //       toast.warning("Please login with RSM", {
    //         position: "top-right",
    //         autoClose: 3000,
    //       });
    //       return; // stop further execution
    //     }

    //     // Await all async data loads
    //     await this.props.getRoleDDL(rowData.UserType);
    //     // await this.props.getSDDL(rowData.State);
    //     if (String(userRole) !== "1" && rowData.RoleName !== "RSM" || rowData.RoleName !== "Vendor" 
    //   || rowData.RoleName !== "Warranty Verification" || rowData.RoleName !== "Accounts" ||rowData.RoleName !== "Logistics" ) {
    //       if (rowData.RegionId != null) {
    //         await this.props.getSDDL(rowData.RegionId);
    //       }

    //       if (rowData.State) {
    //         await this.props.getDistrictDDL(rowData.State);
    //       }

    //       const cityParam = rowData.District || rowData.DistrictIdASM;
    //       if (cityParam) {
    //         await this.props.getCityDDL(cityParam);
    //       }
    //     }

    //     // const cityData = await this.props.getCityDDL(rowData.District); // assumed to return array

    //     await this.props.getRDDL(1);
    //     await this.props.getASMDDL(rowData.State);
    //     await this.props.getGDDL(rowData.DealerGradeId);
    //     this.props.onHideShow(true);

    //     // Get selected city from freshly loaded city data
    //     // const selectedRegion = this.props.UserRData?.find(
    //     //  (x) => String(x.value) === String(rowData.RegionId)
    //     // );

    //   let selectedRegion;
    //   if (rowData.RoleName === "RSM") {
    //   selectedRegion = (this.props.UserRData ||[]).find((x) => {
    //   const label = (x.label ?? "").toString();        // safe string
    //   const region = (rowData.Region ?? "").toString(); // safe string

    //    return (
    //   String(x.value) === String(rowData.RegionId) ||
    //   label.trim().toLowerCase() === region.trim().toLowerCase()
    //   );
    //   });
    //   } else {
    //   selectedRegion = (this.props.UserRData ||[]).find(
    //  (x) => String(x.value) === String(rowData.RegionId)
    //     );
    //     }
    //     // Get selected city from freshly loaded city data
    //     const selectedCity = (this.props.UserCityData ||[]).find(
    //       (x) => String(x.value) === String(rowData.City)
    //     );
    //     // const selectdState = this.props.UserSData?.find(
    //     //   (x) => x.label?.trim().toLowerCase() === rowData.State?.trim().toLowerCase()
    //       // );
    //    const stateName = rowData.State || rowData.StateName || "";
    //       const selectdState = (this.props.UserSData ||[]).find(
    //           (x) => x.label?.trim().toLowerCase() === stateName.toLowerCase()
    //       ) || this.props.UserSData?.find(
    //           (x) => String(x.value) === String(rowData.State || rowData.StateName)
    //       );
    //     //     const selectdState = this.props.UserSData?.find(
    //     // (x) => String(x.value) === String(rowData.State) ||
    //     //     String(x.value) === String(rowData.StateName)
    //     //     );
    //     //const selectedReason = 

    //     const selectedDistrict = (this.props.UserDistrictData ||[]).find(
    //       (x) => String(x.value) === String(rowData.District) ||
    //             String(x.value) === String(rowData.DistrictIdASM) ||
    //             String(x.value) === String(rowData.DistrictId)
    //     );
    //     const selectedRole = (this.props.UserRoleData||[]).find(
    //       (x) => String(x.value) === String(rowData.RoleId)
    //     );
        
    //     const roleName =
    //       selectedRole?.label?.trim() || rowData.RoleName?.trim() || "";

    //     const selectedSalesPerson = (this.props.UserASMData ||[]).find(
    //       (x) => String(x.value) === String(rowData.SalespersonId)
    //     );
    //     const imagePath = rowData.CounterImage?.startsWith("http")
    //       ? rowData.CounterImage
    //       : `https://localhost:44348/files/${rowData.CounterImage}`;

    //     const selectedDealerGrade = (this.props.DealerGData||[]).find(
    //       (x) =>
    //         x.label.trim().toLowerCase() ===
    //         rowData.DealerGrade?.trim().toLowerCase()
    //     );  
      
    //     // Final setState after all data ready
    //     this.setState({
    //       buttonLabel: "Update",
    //       formHeading: "Update User",
    //       UserId: rowData.UserId || 0,
    //       UserName: rowData.UserName,
    //       Email: rowData.Email,
    //       DealerMobileNo: rowData.MobileNo,
    //       RoleId: rowData.RoleId,
    //       RoleName: roleName,
    //       //Region: selectedRegion?.value || rowData.RegionId || rowData.Region,
    //       Region: rowData.RegionId ? rowData.RegionId.split(',').map(Number) : [],

    //       RegionLabel: selectedRegion?.label || rowData.Region || "",
    //       /*State: rowData.State,*/
    //       //State: selectdState?.value || rowData.State,
    //       State: rowData.State ? rowData.State.split(',').map(Number) : [],
    //       // District: selectedDistrict?.value || rowData.District,
    //       // DistrictLabel: selectedDistrict?.label || "",                    
    //       // District:
    //       //   rowData.RoleName === "ASM"
    //       //     ? selectedDistrict?.value || rowData.DistrictIdASM
    //       //     : selectedDistrict?.value || rowData.District,
    //       // DistrictLabel: selectedDistrict?.label || "",
    //       District: rowData.District ? rowData.District.split(',').map(Number) : [],

    //       //City: selectedCity?.value || rowData.City,
    //       City: rowData.City ? rowData.City.split(',').map(Number) : [],

    //       CityLabel: selectedCity?.label || "",
    //       useManualCity: false,
    //       SalesPerson: selectedSalesPerson?.value || "",
    //       SalesPersonLabel: selectedSalesPerson?.label || "",
    //       CounterImage: imagePath,
    //       GSBPhotoPreview: imagePath,
    //       DealerGradeId: selectedDealerGrade?.value || "",
    //       DealerGradeLabel: selectedDealerGrade?.label || "",
    //       MarketPlace: rowData.MarketPlace || "",
    //       MarketType: rowData.MarketType || "",
    //       CounterName: rowData.CounterName || "",
    //       DealerTypeId: [1, 2, 3].includes(rowData.DealerType)
    //         ? rowData.DealerType
    //         : 1,
    //       OwnerName: rowData.OwnerName || "",
    //       useManualEntry: false,
    //       LinkedPrimaryDealerName: rowData.LinkedPrimaryDealerName || "",
    //       BusinessPotentialPerMonth: rowData.BusinessPotentialPerMonth || "",
    //       DealerGrade: rowData.DealerGrade,
    //       WareHouseId: rowData.WareHouseId || "",
    //       SellingXPProductId: rowData.IsSellingExtraPower ? 1 : 2,
    //       IsActive: rowData.IsActive,
    //       Password: rowData.Password,
    //       ConfirmPassword: rowData.Password,
    //       CreatedDate: rowData.CreatedDate,
    //       UserTypeId: rowData.UserType,
    //       CompanyId: rowData.CompanyId || 1,
    //       CreatedBy: rowData.CreatedBy || 0,
    //       UpdatedByUser: rowData.UpdatedByUser || 0,
    //       SaltPassword: rowData.SaltPassword || "",
    //     });

    //   } catch (err) {
    //     console.error("editMode error:", err);
    //   }
    // };
  // Inside your class component
 const editMode = async (rowData) => {
  debugger;

  try {
    const userRole = JSON.parse(sessionStorage.getItem("UserRole"));

    // Prevent Dealer/ASM login for userRole 1
    if (
      String(userRole) === "1" &&
      (rowData.RoleName === "Dealer" || rowData.RoleName === "ASM")
    ) {
      toast.warning("Please login with RSM", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    // --- Await all async dropdown data ---
    await this.props.getRoleDDL(rowData.UserType);
    if (
      (String(userRole) !== "1" && rowData.RoleName !== "RSM") ||
      rowData.RoleName !== "Vendor" ||
      rowData.RoleName !== "Warranty Verification" ||
      rowData.RoleName !== "Accounts" ||
      rowData.RoleName !== "Logistics"
    ) {
      if (rowData.Region != null) await this.props.getSDDL(rowData.Region);
      if (rowData.State) await this.props.getDistrictDDL(rowData.State);
      const cityParam = rowData.District || rowData.DistrictIdASM;
      if (cityParam) await this.props.getCityDDL(cityParam);
    }

    await this.props.getRDDL(1);
    await this.props.getASMDDL(rowData.State);
    await this.props.getGDDL(rowData.DealerGradeId);

    this.props.onHideShow(true);

    // --- Safe defaults for props arrays ---
    const {
      UserRData = [],
      UserCityData = [],
      UserSData = [],
      UserDistrictData = [],
      UserRoleData = [],
      UserASMData = [],
      DealerGData = [],
    } = this.props || {};

    // --- Safe lookups using optional chaining ---
    debugger;
    // const selectedRegion =
    //   rowData.RoleName === "RSM"
    //     ? UserRData.find(
    //         (x) =>
    //           String(x.value) === String(rowData.Region) ||
    //           (x.label ?? "").trim().toLowerCase() ===
    //             (rowData.Region ?? "").toString().trim().toLowerCase()
    //       ) || null
    //     : UserRData.find((x) => String(x.value) === String(rowData.Region)) ||
    //       null;
     let regionValues = [];
     let regionLabels = "";
     if (rowData.Region) {
     regionValues = rowData.Region
     .toString()
     .split(",")
     .map((id) => id.trim())
     .filter((id) => id !== ""); // keep strings

    if (UserRData.length > 0) {
       const selectedRegions = UserRData.filter((r) =>
       regionValues.includes(String(r.value))
      );
      regionLabels = selectedRegions.map((r) => r.label).join(", ");
    } else {
      regionLabels = rowData.Region; // fallback
    }
     }

     let cityValues = [];
     let cityLabels = "";

    if (rowData.City) {
      cityValues = rowData.City
      .toString()
      .split(",")
      .map(id => id.trim())
      .filter(id => id !== ""); // keep strings

    if (UserCityData && UserCityData.length > 0) {
      const selectedCities = UserCityData.filter(c => cityValues.includes(String(c.value)));
      cityValues = selectedCities.map(c => String(c.value)); // ensure strings
      cityLabels = selectedCities.map(c => c.label).join(", ");
    } else {
      cityLabels = rowData.City; // fallback
    }
     }
    // const selectedCity =
    //   UserCityData.find((x) => String(x.value) === String(rowData.City)) ||
    //   null;
    // const selectedDistrict =
    //   UserDistrictData.find((x)=>String(x.value)===String(rowData.DistrictIdASM))|| null;
    const stateName = rowData.State || rowData.StateName || "";
       const selectedState =
        UserSData.find(
         (x) => x.label?.trim().toLowerCase() === stateName.toLowerCase()
          ) ||
       UserSData.find(
        (x) => String(x.value) === String(rowData.State || rowData.StateName)
        ) ||
       null;
      debugger;
// let districtValues = [];
// let districtLabels = [];

// if (rowData.DistrictIdASM) {
//   const districtIdsASM = (rowData.DistrictIdASM || "").split(",").map(id => id.trim());
  
//   // Ensure district data is loaded and available
//   if (UserDistrictData && UserDistrictData.length > 0) {
//     const selectedDistrict = UserDistrictData.filter(x =>
//       districtIdsASM.includes(String(x.value)) ||
//       String(x.value) === String(rowData.District) ||
//       String(x.value) === String(rowData.DistrictId)
//     );
    
//     districtValues = selectedDistrict.map(d => Number(d.value));
//     districtLabels = selectedDistrict.map(d => d.label).join(", ");
//   } else {
//     // If data isn't available yet, store the IDs and set them later
//     districtValues = districtIdsASM.map(Number).filter(id => !isNaN(id));
//     districtLabels = rowData.DistrictIdASM; // Fallback to raw value
//   }
// }
       let districtValues = [];
       let districtLabels = "";
        if (rowData.RoleName === "Dealer") {
  // Handle Dealer district data
        if (rowData.District) {
       const districtIds = rowData.District.split(",").map(id => id.trim());
       districtValues = districtIds.map(Number).filter(id => !isNaN(id));
    
    // Get labels from currently loaded district data
    if (UserDistrictData && UserDistrictData.length > 0) {
      const selectedDistricts = UserDistrictData.filter(district =>
        districtValues.includes(Number(district.value))
      );
      districtLabels = selectedDistricts.map(d => d.label).join(", ");
    } else {
      districtLabels = rowData.District; // Fallback to raw value
    }
  }

  } else if (rowData.RoleName === "ASM") {
  if (rowData.DistrictIdASM) {
    const districtIdsASM = (rowData.DistrictIdASM || "")
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id !== ""); // keep strings

    if (UserDistrictData && UserDistrictData.length > 0) {
      const selectedDistrict = UserDistrictData.filter(
        (x) =>
          districtIdsASM.includes(String(x.value)) ||
          String(x.value) === String(rowData.District) ||
          String(x.value) === String(rowData.DistrictId)
      );
      districtValues = selectedDistrict.map((d) => String(d.value)); // force strings
      districtLabels = selectedDistrict.map((d) => d.label).join(", ");
    } else {
      districtValues = districtIdsASM; // already strings
      districtLabels = rowData.DistrictIdASM;
    }
  }
}


    const selectedRole =
      UserRoleData.find((x) => String(x.value) === String(rowData.RoleId)) ||
      null;

    const roleName = selectedRole?.label?.trim() || rowData.RoleName?.trim() || "";

    const selectedSalesPerson =
      UserASMData.find((x) => String(x.value) === String(rowData.SalespersonId)) ||
      null;

    const selectedDealerGrade =
      DealerGData.find(
        (x) =>
          x.label?.trim().toLowerCase() ===
          rowData.DealerGrade?.trim().toLowerCase()
      ) || null;

    const imagePath = rowData.CounterImage?.startsWith("http")
      ? rowData.CounterImage
      : `https://localhost:44348/files/${rowData.CounterImage}`;

    // --- Set state safely ---
    this.setState({
      buttonLabel: "Update",
      formHeading: "Update User",
      UserId: rowData.UserId || 0,
      UserName: rowData.UserName || "",
      Email: rowData.Email || "",
      DealerMobileNo: rowData.MobileNo || "",
      RoleId: rowData.RoleId || "",
      RoleName: roleName,
      //Region:rowData.Region ||[],
      // Region: rowData.Region ? rowData.Region.split(",").map(Number): [],
      // RegionLabel: selectedRegion?.label || "",
      Region: regionValues,
      RegionLabel: regionLabels,
        // RegionLabel: selectedRegion?.label || rowData.Region || "",
      State: rowData.State ? rowData.State.split(",").map(Number) : [],
      //  District: selectedDistrict.map((d) => Number(d.value)),
      // DistrictLabel:districtLabels,
      District: districtValues,
      DistrictLabel: districtLabels,
      // City: rowData.City ? rowData.City.split(",").map(Number) : [],
      // CityLabel: selectedCity?.label || "",
       City: cityValues,
       CityLabel: cityLabels,
      useManualCity: false,
      SalesPerson: selectedSalesPerson?.value || "",
      SalesPersonLabel: selectedSalesPerson?.label || "",
      CounterImage: imagePath,
      GSBPhotoPreview: imagePath,
      DealerGradeId: selectedDealerGrade?.value || "",
      DealerGradeLabel: selectedDealerGrade?.label || "",
      MarketPlace: rowData.MarketPlace || "",
      MarketType: rowData.MarketType || "",
      CounterName: rowData.CounterName || "",
      DealerTypeId: [1, 2, 3].includes(rowData.DealerType)
        ? rowData.DealerType
        : 1,
      OwnerName: rowData.OwnerName || "",
      useManualEntry: false,
      LinkedPrimaryDealerName: rowData.LinkedPrimaryDealerName || "",
      BusinessPotentialPerMonth: rowData.BusinessPotentialPerMonth || "",
      DealerGrade: rowData.DealerGrade || "",
      WareHouseId: rowData.WareHouseId || "",
      SellingXPProductId: rowData.IsSellingExtraPower ? 1 : 2,
      IsActive: rowData.IsActive || false,
      Password: rowData.Password || "",
      ConfirmPassword: rowData.Password || "",
      CreatedDate: rowData.CreatedDate || "",
      UserTypeId: rowData.UserType || "",
      CompanyId: rowData.CompanyId || 1,
      CreatedBy: rowData.CreatedBy || 0,
      UpdatedByUser: rowData.UpdatedByUser || 0,
      SaltPassword: rowData.SaltPassword || "",
    });
    
  } catch (err) {
    console.error("editMode error:", err);
  }
};


    const switchHandleChange = () => {
      this.setState({
        switchAction: !rowData.IsActive,
        UserId: rowData.UserId,
      });
      this.props.onHideShowIsActive(true);
    };

    if (rowData && this.state.IsEdit && rowData.RoleId !== 4) {
      return (
        <div>
          <Switch
            checked={rowData.IsActive}
            color="primary"
            name={rowData.UserId}
            onChange={switchHandleChange}
            inputProps={{ "aria-label": "secondary checkbox" }}
          />
          <Button icon="pi pi-pencil"
          //  onClick={editMode} 
           onClick={() => editMode(rowData)}

          // onClick={() => setTimeout(() => this.editMode(), 50)}

          />
        </div>
      );
    }

    return null;
  }


  exportCSV() {
    this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    this.tblResponse.First = -1;
    this.tblResponse.PageSize = -1;
    this.props.exportData(this.tblResponse);
    setTimeout(() => {
      this.csvLink.current.link.click();
    }, 3000);
  }

  exportCSVAll() {
    this.tblResponse.FromDate = "2022-01-01";
    this.tblResponse.ToDate = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    this.tblResponse.First = -1;
    this.tblResponse.PageSize = -1;
    this.props.exportData(this.tblResponse);
    setTimeout(() => {
      this.csvLink.current.link.click();
    }, 3000);
  }

  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
  }

  render() {
     console.log("UserSData:", this.props.Wdd2); 
    const { useManualEntry, LinkedPrimaryDealerName, formError } = this.state;

    const renderFooter = () => {
      return (
        <div>
          <Button
            label="No"
            icon="pi pi-times"
            onClick={() => this.props.onHideShowIsActive(false)}
            className="p-button-text"
          />
          <Button
            label="Yes"
            icon="pi pi-check"
            onClick={this.switchToggleConfirm}
            autoFocus
          />
        </div>
      );
    };
    const header = (
      <div className="table-header row">
        <div className="col-md-6">
          <h4 className="user">User Master</h4>
        </div>

      </div>
    );

    return (
      <div className="datatable-filter-demo">
        <ToastContainer />
        <div className="table-header row mb-3">
          <div className="col-md-6">
            <h5 className="main-head">User Master</h5>
          </div>

          <div className="col-md-6 d-flex justify-content-end">
            <div className="search d-flex align-items-center">
              <span className="p-input-icon-left mr-2">
                <i className="pi pi-search" />
                <InputText
                  type="search"
                  onInput={(e) => this.searchFilter(e)}
                  placeholder="Global Search"
                />
              </span>
              {this.state.IsAdd && (
                <Button
                style={{ marginLeft: "10px" }}
                  label="Add User"
                  icon="pi pi-plus-circle"
                  onClick={this.openDialog}
                />
              )}
            </div>
          </div>

        </div>
        <div className="table-header row mb-3">
          <div className="col-md-4">
            <Calendar
              placeholder="From Date"
              name="FromDate"
              showIcon
              value={this.state.FromDate}
              //onChange={(e) => this.handleChangeDate(e.value, { name: 'FromDate' })}
              onChange={this.handleChangeDate}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-md-4">
            <Calendar
              placeholder="To Date"
              name="ToDate"
              showIcon
              value={this.state.ToDate}
              // onChange={(e) => this.handleChangeDate('ToDate', e.value)}
              onChange={this.handleChangeDate}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-md-1">
            <button
              type="button"
              onClick={this.FilterData}
              className="btn btn-primary p-2 pl-3 pr-3 mr-2"
            >
              Submit
            </button>
          </div>
          <div className="col-md-3 text-right">
            <button
              onClick={this.exportCSV}
              className="btn btn-success p-2 pl-3 pr-3 ml-2"
            >
              Export
            </button>
            <button
              onClick={this.exportCSVAll}
              className="btn btn-success p-2 pl-3 pr-3 ml-2"
            >
              Export All
            </button>
          </div>
          <CSVLink
            hidden
            data={this.props.List}
            filename={"User Report.csv"}
            target="_blank"
            ref={this.csvLink}
          />
        </div>
        <div className="card">
          <DataTable
            value={this.props.UserData}
            scrollable
            responsive={true}
            globalFilter={this.state.globalFilter}
            header={header}
            emptyMessage="No data found."
            sortMode="multiple"
            paginator={true}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={this.state.rows}
            style={{ width: "100%" }}
            rowsPerPageOptions={[5, 10, 20]}
            totalRecords={parseInt(this.state.totalRecords)}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            loading={this.props.loading}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column
              field="UserName"
              style={{ width: "12%" }}
              header="User Name"
              sortable
            />
            <Column
              field="RoleName"
              style={{ width: "12%" }}
              header="Role Name"
              sortable
            />
            <Column
              style={{ width: "20%" }}
              field="Email"
              header="Email"
              sortable
            />
            <Column
              style={{ width: "18%" }}
              field="MobileNo"
              header="Mobile Number"
              sortable
            />
            <Column
              style={{ display: "none" }}
              // style={{ width: "18%" }}
              field="District"
              header="District"
              sortable
            />
            <Column
              style={{ width: "15%" }}
              field="StateName"
              header="State"
              sortable
            />
            <Column
              style={{ width: "15%" }}
              field="CityName"
              header="City"
              sortable
            />
            {this.state.IsEdit && (
              <Column
                field="Action"
                header="Action"
                style={{ width: "20%" }}
                body={this.actionBodyTemplate}
                className="text-center"
              />
            )}
          </DataTable>
        </div>
        <Dialog
          header={this.state.formHeading}
          modal
          dismissableMask
          visible={this.props.showDialog}
          className="popup"
          onHide={this.onHide}
        >
          <form onSubmit={this.submitForm} autoComplete="off">
            <div className="row">
              <div className="col-md-6 pt-3">
                <TextField
                  //onChange={this.handleChange}
                  onChange={(e) => {
                    this.handleChange(e);
                    this.validateForm(e.target.value, e.target.name);
                  }}
                  name="UserName"
                  value={this.state.UserName}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="User Name*"
                />
                {this.state.formError.UserName && (
                  <div className="error">{this.state.formError.UserName}</div>
                )}
              </div>
              <div className="col-md-6 pt-3">
                <FormControl variant="outlined" size="small" className="formControl col-md-12">
                  <InputLabel>Select User Type*</InputLabel>
                  <Select
                    onChange={this.getRoleList}
                    name="UserTypeId"
                    value={this.state.UserTypeId}
                    label="Select User Type"
                  >
                    {/* <MenuItem value={0}><em>none</em></MenuItem> */}
                    {this.state.UserTypeData.map((key) => (
                      <MenuItem key={key.value} value={key.value}>{key.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {this.state.formError.UserTypeId && (
                  <div className="error">{this.state.formError.UserTypeId}</div>
                )}
              </div>
              <div className="col-md-6 pt-3">
                <FormControl variant="outlined" size="small" className="formControl col-md-12">
                  <InputLabel>Select User Role*</InputLabel>
                  <Select
                    //onChange={this.handleChange}
                    onChange={(e) => {
                      this.handleChange(e);
                      this.validateForm(e.target.value, e.target.name);
                    }}
                    name="RoleId"
                    value={this.state.RoleId}
                    label="Select User Role"
                  >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {this.props.UserRoleData?.map((key) => (
                      <MenuItem key={key.value} value={key.value}>{key.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {this.state.formError.RoleId && (
                  <div className="error">{this.state.formError.RoleId}</div>
                )}
              </div>

              {this.state.RoleName === "RSM" && (
                <div className="col-md-6 pt-3">
                  <FormControl variant="outlined" size="small" className="formControl col-md-12">
  <InputLabel>Select Region*</InputLabel>
  <Select
    multiple
    onChange={this.handleRChange}
    name="Region"
    value={this.state.Region || []}
    label="Select Region"
    renderValue={(selected) => {
      if (!Array.isArray(selected)) return "";
      const regionData = this.props.UserRData || [];
      return selected
        .map((val) => regionData.find(item => String(item.value) === String(val))?.label)
        .filter(Boolean)
        .join(", ");
    }}
  >
    {this.props.UserRData?.map((key) => (
      <MenuItem
        key={key.value}
        value={key.value}
        sx={{
          '&.Mui-selected': { backgroundColor: '#4caf50' },
          '&.Mui-selected:hover': { backgroundColor: '#45a049' },
        }}
      >
        <Checkbox
  checked={(this.state.Region || []).includes(String(key.value))}
        />
        <ListItemText primary={key.label} />
      </MenuItem>
    ))}
  </Select>
</FormControl>

{this.state.formError.Region && (
  <div className="error">{this.state.formError.Region}</div>
)}

                  {this.state.formError.Region && (
                    <div className="error">{this.state.formError.Region}</div>
                  )}
                </div>
              )}

              {this.state.RoleName === "Dealer" && (
                <>
                  {/* <div className="col-md-6 pt-3">
                    <FormControl variant="outlined" size="small" className="formControl col-md-12">
                      <InputLabel>Select Warehouse*</InputLabel>
                      <Select
                        onChange={this.handleWChange}
                        name="WareHouseId"
                        value={this.state.WareHouseId}
                        label="Select Warehouse"
                      >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {this.props.UserWData?.map((key) => (
                          <MenuItem key={key.value} value={key.value}>{key.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {this.state.formError.WareHouseId && (
                      <div className="error">{this.state.formError.WareHouseId}</div>
                    )}
                  </div> */}

                  {this.state.RoleName !== "Dealer" && (
                    <div className="col-md-6 pt-3">
                      <FormControl variant="outlined" size="small" className="formControl col-md-12">
                        <InputLabel>Select Warehouse*</InputLabel>
                        <Select
                          onChange={this.handleWChange}
                          name="WareHouseId"
                          value={this.state.WareHouseId}
                          label="Select Warehouse"
                        >
                          <MenuItem value=""><em>None</em></MenuItem>
                          {this.props.UserWData?.map((key) => (
                            <MenuItem key={key.value} value={key.value}>{key.label}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      {this.state.formError.WareHouseId && (
                        <div className="error">{this.state.formError.WareHouseId}</div>
                      )}
                    </div>
                  )}
                  <div className="col-md-6 pt-3">
                    <FormControl variant="outlined" size="small" className="formControl col-md-12">
                      <InputLabel>Select SalesPerson*</InputLabel>
                      <Select
                        onChange={this.handleASMChange}
                        name="SalesPerson"
                        value={this.state.SalesPerson}
                        label="Select SalesPerson"
                      >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {this.props.UserASMData?.map((key) => (
                          <MenuItem key={key.value} value={key.value}>{key.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {this.state.formError.SalesPerson && (
                      <div className="error">{this.state.formError.SalesPerson}</div>
                    )}
                  </div>

                  <div className="col-md-6 pt-3">
                      <FormControl variant="outlined" size="small" className="formControl col-md-12">
                        <InputLabel>Select State*</InputLabel>
                        <Select
                          multiple
                          onChange={this.getDistrictList}
                          name="State"
                          value={this.state.State ||[]}
                            //value={Array.isArray(this.state.State) ? this.state.State : [this.state.State]}
                          label="Select State"
                      //     renderValue={(selected) => {
                      //     if (!Array.isArray(selected)) return ""; // safeguard
                      //   return selected
                      // .map((val) => this.props.UserSData.find(item => Number(item.value) === Number(val))?.label)
                      // .filter(Boolean)
                      // .join(", ");
                      // }}
                      renderValue={(selected) => {
                      if (!Array.isArray(selected)) return "";
                      const userSData = this.props.UserSData || [];
                      return selected
                      .map((val) => userSData.find(item => Number(item.value) === Number(val))?.label)
                      .filter(Boolean)
                      .join(", ");
              }}
                      >
                        {this.props.UserSData?.map((state) => (
                          // <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
                          <MenuItem key={state.value} value={state.value}>
                          <Checkbox checked={this.state.State?.indexOf(state.value) > -1} />
                          <ListItemText primary={state.label} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {this.state.formError.State && (
                      <div className="error">{this.state.formError.State}</div>
                    )}
                  </div>

                   <div className="col-md-6 pt-3">
                    <FormControl variant="outlined" size="small" className="formControl col-md-12">
                 <InputLabel>Select District*</InputLabel>
                <Select
  multiple
  name="District"
  value={this.state.District || []}
  onChange={(e) => {
    const { value } = e.target;
    const districtData = this.props.UserDistrictData || [];
    const allValues = districtData.map(d => String(d.value));

    let newDistrict;
    if (value.includes("all")) {
      newDistrict =
        (this.state.District || []).length === allValues.length ? [] : allValues;
    } else {
      newDistrict = value;
    }

    this.setState({ District: newDistrict }, () => {
      if (typeof this.getCityList === "function") {
        this.getCityList({ target: { name: "District", value: newDistrict } });
      }
    });
  }}
  renderValue={(selected) => {
    if (!Array.isArray(selected)) return "";
    const districtData = this.props.UserDistrictData || [];
    return selected
      .map(
        (val) =>
          districtData.find((item) => String(item.value) === String(val))?.label
      )
      .filter(Boolean)
      .join(", ");
  }}
>
  <MenuItem value="all">
    <Checkbox
      checked={
        (this.state.District || []).length ===
        (this.props.UserDistrictData || []).length
      }
      indeterminate={
        (this.state.District || []).length > 0 &&
        (this.state.District || []).length <
          (this.props.UserDistrictData || []).length
      }
    />
    <ListItemText primary="Select All" />
  </MenuItem>

  {this.props.UserDistrictData?.map((key) => (
    <MenuItem key={key.value} value={String(key.value)}>
      <Checkbox
        checked={(this.state.District || []).includes(String(key.value))}
      />
      <ListItemText primary={key.label} />
    </MenuItem>
  ))}
</Select>
              </FormControl>
                    {this.state.formError.District && (
                      <div className="error">{this.state.formError.District}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    {/* Toggle between dropdown and manual */}
                    <FormControl component="fieldset" className="mb-2">
                      <RadioGroup
                        row
                        value={this.state.useManualCity ? "manual" : "select"}
                        onChange={(e) => this.setState({ useManualCity: e.target.value === "manual", City: "" })}
                      >
                        <FormControlLabel value="select" control={<Radio color="default" sx={{ '&.Mui-checked': { color: 'black' } }} />} label="Select City" />
                        <FormControlLabel value="manual" control={<Radio color="default" sx={{ '&.Mui-checked': { color: 'black' } }} />} label="Manual Entry" />
                      </RadioGroup>
                    </FormControl>

                    {/* Conditionally render either Select or TextField */}
                    {this.state.useManualCity ? (
                      <TextField
                        variant="outlined"
                        size="small"
                        className="formControl col-md-12"
                        label="Enter City*"
                        name="City"
                        value={this.state.City}
                        //onChange={this.handleChange}
                        onChange={(e) => {
                          this.handleChange(e);
                          this.validateForm(e.target.value, e.target.name);
                        }}
                      />
                    ) : (
                      <FormControl
                   variant="outlined"
                   size="small"
                   className="formControl col-md-12"
                   onClick={this.handleCityClick} 
                   >
                  <InputLabel>Select City*</InputLabel>

  {!(this.props.UserRole === "ASM" && this.state.cityClickCount < 2) && (
    <Select
      multiple
      value={this.state.City || []}
      onChange={this.handleCityChange}
      name="City"
      label="Select City"
      renderValue={(selected) => {
        if (!Array.isArray(selected) || !this.props.UserCityData) return "";
        return selected
          .map(
            (val) =>
              this.props.UserCityData.find(
                (item) => String(item.value) === String(val)
              )?.label
          )
          .filter(Boolean)
          .join(", ");
      }}
    >
      {/* Select All */}
      <MenuItem value="ALL">
        <Checkbox
          checked={
            (this.state.City?.length || 0) ===
            (this.props.UserCityData?.length || 0)
          }
        />
        <ListItemText primary="Select All" />
      </MenuItem>

      {/* Individual cities */}
      {this.props.UserCityData?.map((city) => (
        <MenuItem key={city.value} value={String(city.value)}>
          <Checkbox
            checked={(this.state.City || []).includes(String(city.value))}
          />
          <ListItemText primary={city.label} />
        </MenuItem>
      ))}
    </Select>
  )}
</FormControl>
                    )}

                    {/* Error message */}
                    {this.state.formError.City && (
                      <div className="error">{this.state.formError.City}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <TextField
                      //onChange={this.handleChange}
                      onChange={(e) => {
                        this.handleChange(e);
                        this.validateForm(e.target.value, e.target.name);
                      }}
                      name="MarketPlace"
                      value={this.state.MarketPlace}
                      size="small"
                      variant="outlined"
                      className="fullwidth"
                      label="Market Place*"
                    />
                    {this.state.formError.MarketPlace && (
                      <div className="error">{this.state.formError.MarketPlace}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <TextField
                      // onChange={this.handleChange}
                      onChange={(e) => {
                        this.handleChange(e);
                        this.validateForm(e.target.value, e.target.name);
                      }}
                      name="MarketType"
                      value={this.state.MarketType}
                      size="small"
                      variant="outlined"
                      className="fullwidth"
                      label="Market Type*"
                    />
                    {this.state.formError.MarketType && (
                      <div className="error">{this.state.formError.MarketType}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <TextField
                      // onChange={this.handleChange}
                      onChange={(e) => {
                        this.handleChange(e);
                        this.validateForm(e.target.value, e.target.name);
                      }}
                      name="CounterName"
                      value={this.state.CounterName}
                      size="small"
                      variant="outlined"
                      className="fullwidth"
                      label="Counter Name*"
                    />
                    {this.state.formError.CounterName && (
                      <div className="error">{this.state.formError.CounterName}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <FormControl variant="outlined" size="small" className="formControl col-md-12">
                      <InputLabel>Select Dealer Type*</InputLabel>
                      <Select
                        // onChange={this.handleChange}
                        onChange={(e) => {
                          this.handleChange(e);
                          this.validateForm(e.target.value, e.target.name);
                        }}
                        name="DealerTypeId"
                        value={this.state.DealerTypeId}
                        label="Select Dealer Type"
                      >
                        <MenuItem value={0}><em>None</em></MenuItem>
                        {this.state.DealerTypeData.map((key) => (
                          <MenuItem key={key.value} value={key.value}>{key.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {this.state.formError.DealerTypeId && (
                      <div className="error">{this.state.formError.DealerTypeId}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <TextField
                      // onChange={this.handleChange}
                      onChange={(e) => {
                        this.handleChange(e);
                        this.validateForm(e.target.value, e.target.name);
                      }}
                      name="OwnerName"
                      value={this.state.OwnerName}
                      size="small"
                      variant="outlined"
                      className="fullwidth"
                      label="Owner Name*"
                    />
                    {this.state.formError.OwnerName && (
                      <div className="error">{this.state.formError.OwnerName}</div>
                    )}
                  </div>
                  {/* <div className="col-md-6 pt-3">
                    <TextField
                      onChange={this.handleChange}
                      name="LinkedPrimaryDealerName"
                      value={this.state.LinkedPrimaryDealerName}
                      size="small"
                      variant="outlined"
                      className="fullwidth"
                      label="Primary Dealer Name*"
                    />
                    {this.state.formError.LinkedPrimaryDealerName && (
                      <div className="error">{this.state.formError.LinkedPrimaryDealerName}</div>
                    )}
                  </div>
                   */}

                  <div className="col-md-6 pt-3">
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        value={useManualEntry ? "manual" : "select"}
                        onChange={this.handleToggleChange}
                      >
                        <FormControlLabel
                          value="manual"
                          control={
                            <Radio
                              color="default"
                              sx={{
                                color: 'black',
                                '&.Mui-checked': {
                                  color: 'black',
                                },
                              }}
                            />
                          }
                          label="Manual Entry"
                        />

                        <FormControlLabel
                          value="select"
                          control={
                            <Radio
                              color="default"
                              sx={{
                                color: 'black',
                                '&.Mui-checked': {
                                  color: 'black',
                                },
                              }}
                            />
                          }
                          label="Select Option"
                        />
                      </RadioGroup>
                    </FormControl>

                    {useManualEntry ? (
                      <TextField
                        onChange={this.handleChange}
                        name="LinkedPrimaryDealerName"
                        value={LinkedPrimaryDealerName}
                        size="small"
                        variant="outlined"
                        className="fullwidth"
                        label="Primary Dealer Name*"
                      />
                    ) : (
                      <FormControl variant="outlined" size="small" className="fullwidth">
                        <InputLabel id="dealer-select-label">Primary Dealer Name*</InputLabel>
                        <Select
                          labelId="dealer-select-label"
                          name="LinkedPrimaryDealerName"
                          value={LinkedPrimaryDealerName}
                          onChange={this.handleChange}
                          label="Primary Dealer Name*"
                        >
                          <MenuItem value="Option for 2 Primary Dlr names">Option for 2 Primary Dlr names</MenuItem>
                          <MenuItem value="Buying from Market">Buying from Market</MenuItem>
                          <MenuItem value="Not Applicable">Not Applicable</MenuItem>
                        </Select>
                      </FormControl>
                    )}

                    {formError.LinkedPrimaryDealerName && (
                      <div className="error">{formError.LinkedPrimaryDealerName}</div>
                    )}
                  </div>

                  <div className="col-md-6 pt-3">
                    <label htmlFor="GSBPhoto">Picture of Counter/Visiting Card*</label>
                    <input
                      type="file"
                      accept="image/*"
                      name="GSBPhoto"
                      onChange={this.handleFileChange}
                      className="form-control"
                    />
                    {this.state.formError.GSBPhoto && (
                      <div className="error">{this.state.formError.GSBPhoto}</div>
                    )}
                    {this.state.GSBPhotoPreview && (
                      <div className="mt-2">
                        <img
                          src={this.state.GSBPhotoPreview}
                          alt="GSB Preview"
                          style={{ maxWidth: "50%", height: "auto", border: "1px solid #ccc" }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <TextField
                      // onChange={this.handleChange}
                      onChange={(e) => {
                        this.handleChange(e);
                        this.validateForm(e.target.value, e.target.name);
                      }}
                      name="BusinessPotentialPerMonth"
                      value={this.state.BusinessPotentialPerMonth}
                      size="small"
                      variant="outlined"
                      className="fullwidth"
                      label="Business Potential (Cr. - Lac)*"
                      type="number"
                    />
                    {this.state.formError.BusinessPotentialPerMonth && (
                      <div className="error">{this.state.formError.BusinessPotentialPerMonth}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <FormControl variant="outlined" size="small" className="formControl col-md-12">
                      <InputLabel>Select Dealer Grade*</InputLabel>
                      <Select
                        onChange={this.handleGChange}
                        name="DealerGradeId"
                        value={this.state.DealerGradeId}
                        label="Select Dealer Grade"
                      >
                        <MenuItem value=""><em>None</em></MenuItem>
                        {this.props.DealerGData?.map((state) => (
                          <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {this.state.formError.DealerGradeId && (
                      <div className="error">{this.state.formError.DealerGradeId}</div>
                    )}
                  </div>
                  <div className="col-md-6 pt-3">
                    <FormControl variant="outlined" size="small" className="formControl col-md-12">
                      <InputLabel>Selling Xtra Power Products*</InputLabel>
                      <Select
                        // onChange={this.handleChange}
                        onChange={(e) => {
                          this.handleChange(e);
                          this.validateForm(e.target.value, e.target.label);
                        }}
                        name="SellingXPProductId"
                        value={this.state.SellingXPProductId}
                        label="Selling Xtra Power Products"
                      >
                        <MenuItem value={0}><em>None</em></MenuItem>
                        {this.state.SellingXPProductData.map((key) => (
                          <MenuItem key={key.value} value={key.value}>{key.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {this.state.formError.SellingXPProductId && (
                      <div className="error">{this.state.formError.SellingXPProductId}</div>
                    )}
                  </div>
                </>
              )}

              {["ASM", "Customer", "Sales Coordinator", "Sales Person", "Accounts Department", "Logistics Department"].includes(this.state.RoleName) && (
                <>

                  <div className="col-md-6 pt-3">
                    <FormControl variant="outlined" size="small" className="formControl col-md-12">
                    <InputLabel>Select State*</InputLabel>
                   <Select
                   multiple
                   name="State"
                   value={this.state.State || []}   // State must be an array
                     onChange={(e) => {
                   this.setState({ State: e.target.value });
                  this.getDistrictList(e);
                    }}
                   renderValue={(selected) => {
                   if (!Array.isArray(selected)) return ""; // safeguard
                   const userSData=this.props.UserSData ||[]
                 return selected
                  .map((val) => userSData.find(item => Number(item.value) === Number(val))?.label)
                   .filter(Boolean)
                  .join(", ");
                 }}
              >
               {this.props.UserSData?.map((state) => (
              <MenuItem key={state.value} value={state.value}>
              <Checkbox checked={this.state.State.indexOf(state.value) > -1} />
             <ListItemText primary={state.label} />
            </MenuItem>
    ))}
  </Select>
</FormControl>

                    

                    {this.state.formError.State && (
                      <div className="error">{this.state.formError.State}</div>
                    )}
                  </div>

                  <div className="col-md-6 pt-3">
                   <FormControl variant="outlined" size="small" className="formControl col-md-12">
                  <InputLabel>Select District*</InputLabel>
       
<Select
  multiple
  name="District"
  value={this.state.District || []}
  onChange={(e) => {
    const { value } = e.target;
    const districtData = this.props.UserDistrictData || [];
    const allValues = districtData.map(d => String(d.value));

    let newDistrict;
    if (value.includes("all")) {
      newDistrict =
        (this.state.District || []).length === allValues.length ? [] : allValues;
    } else {
      newDistrict = value;
    }

    this.setState({ District: newDistrict }, () => {
      if (typeof this.getCityList === "function") {
        this.getCityList({ target: { name: "District", value: newDistrict } });
      }
    });
  }}
  renderValue={(selected) => {
    if (!Array.isArray(selected)) return "";
    const districtData = this.props.UserDistrictData || [];
    return selected
      .map(
        (val) =>
          districtData.find((item) => String(item.value) === String(val))?.label
      )
      .filter(Boolean)
      .join(", ");
  }}
>
  <MenuItem value="all">
    <Checkbox
      checked={
        (this.state.District || []).length ===
        (this.props.UserDistrictData || []).length
      }
      indeterminate={
        (this.state.District || []).length > 0 &&
        (this.state.District || []).length <
          (this.props.UserDistrictData || []).length
      }
    />
    <ListItemText primary="Select All" />
  </MenuItem>

  {this.props.UserDistrictData?.map((key) => (
    <MenuItem key={key.value} value={String(key.value)}>
      <Checkbox
        checked={(this.state.District || []).includes(String(key.value))}
      />
      <ListItemText primary={key.label} />
    </MenuItem>
  ))}
</Select>
</FormControl>
                    {this.state.formError.District && (
                      <div className="error">{this.state.formError.District}</div>
                    )}
                  </div>

                  <div className="col-md-6 pt-3">
                {(this.props.UserRole !== "ASM" || this.state.showCityDropdown )&& (
  <FormControl
  variant="outlined"
  size="small"
  className="formControl col-md-12"
  onClick={this.handleCityClick} // count clicks
>
  <InputLabel>Select City*</InputLabel>

  {!(this.props.UserRole === "ASM" && this.state.cityClickCount < 2) && (
    <Select
      multiple
      value={this.state.City || []}
      onChange={this.handleCityChange}
      name="City"
      label="Select City"
      renderValue={(selected) => {
        if (!Array.isArray(selected) || !this.props.UserCityData) return "";
        return selected
          .map(
            (val) =>
              this.props.UserCityData.find(
                (item) => String(item.value) === String(val)
              )?.label
          )
          .filter(Boolean)
          .join(", ");
      }}
    >
      {/* Select All */}
      <MenuItem value="ALL">
        <Checkbox
          checked={
            (this.state.City?.length || 0) ===
            (this.props.UserCityData?.length || 0)
          }
        />
        <ListItemText primary="Select All" />
      </MenuItem>

      {/* Individual cities */}
      {this.props.UserCityData?.map((city) => (
        <MenuItem key={city.value} value={String(city.value)}>
          <Checkbox
            checked={(this.state.City || []).includes(String(city.value))}
          />
          <ListItemText primary={city.label} />
        </MenuItem>
      ))}
    </Select>
  )}
</FormControl>

)}


                    {this.state.formError.City && (
                      <div className="error">{this.state.formError.City}</div>
                    )}
                  </div>
                </>)}

              <div className="col-md-6 pt-3">
                <TextField
                  // onChange={this.handleChange}
                  onChange={(e) => {
                    this.handleChange(e);
                    this.validateForm(e.target.value, e.target.name);
                  }}
                  name="Email"
                  value={this.state.Email}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Email*"
                />
                {this.state.formError.Email && (
                  <div className="error">{this.state.formError.Email}</div>
                )}
              </div>

              <div className="col-md-6 pt-3">
                <TextField
                  // onChange={this.handleChange}
                  onChange={(e) => {
                    this.handleChange(e);
                    this.validateForm(e.target.value, e.target.name);
                  }}
                  name="DealerMobileNo"
                  value={this.state.DealerMobileNo}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Mobile Number*"
                />
                {this.state.formError.DealerMobileNo && (
                  <div className="error">{this.state.formError.DealerMobileNo}</div>
                )}
                
              </div>
              <div className="col-md-6 pt-3">
                <TextField
                  type="password"
                  // onChange={this.handleChange}
                  onChange={(e) => {
                    this.handleChange(e);
                    this.validateForm(e.target.value, e.target.name);
                  }}
                  name="Password"
                  value={this.state.Password}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Password*"
                />
                {this.state.formError.Password && (
                  <div className="error">{this.state.formError.Password}</div>
                )}
              </div>
              <div className="col-md-6 pt-3">
                <TextField
                  type="password"
                  // onChange={this.handleChange}
                  onChange={(e) => {
                    this.handleChange(e);
                    this.validateForm(e.target.value, e.target.name);
                  }}
                  name="ConfirmPassword"
                  value={this.state.ConfirmPassword}
                  size="small"
                  variant="outlined"
                  className="fullwidth"
                  label="Confirm Password*"
                />
                {this.state.formError.ConfirmPassword && (
                  <div className="error">{this.state.formError.ConfirmPassword}</div>
                )}
              </div>

              <div className="col-md-6 pt-3">
                <Checkbox
                  name="IsActive"
                  checked={this.state.IsActive}
                  onClick={this.handleChange}
                  color="primary"
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
                <label>Is Active</label>
              </div>
              <div className="col-md-12 mt-3 mb-3 text-center">
                {this.state.IsEdit && (
                  <Button label={this.state.buttonLabel} icon="pi pi-check" />
                )}
              </div>
              <div className="col-md-12">
                Note: Fields marked as (*) are required
              </div>
            </div>
          </form>
        </Dialog>
        <Dialog
          header="Confirmation"
          visible={this.props.showIsActiveDialog}
          modal
          style={{ width: "350px" }}
          footer={renderFooter}
          onHide={() => this.props.onHideShowIsActive(false)}
        >
          <div className="confirmation-content">
            <i className="pi pi-exclamation-triangle p-mr-3 confirm-icon" style={{ fontSize: "2rem" }} />
            <span>
              Are you sure you want to {this.state.switchAction ? "Active" : "InActive"}?
            </span>
          </div>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  console.log("data", state);
  
  return {
    UserData: state.user.items,
    UserRoleData: state.role.rollddl,
    UserDistrictData: state.role.districtddl,
    UserCityData: state.role.cityddl,
    UserWData: state.user.Wdd2,
    UserSData: state.user.UserSData,
    UserRData: state.user.UserRData,
    UserASMData: state.user.UserASMData,
    DealerGData: state.user.DealerGData,
    showDialog: state.role.showDialog,
    loading: state.company.loding,
    showIsActiveDialog: state.user.showIsActiveDialog,
    List: state.user.exportitems || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => dispatch(userMasterActions.getAll(obj)),
    createUser: (user) => dispatch(userMasterActions.createUser(user)),
    createUserDetails: (user) => dispatch(userMasterActions.createUserDetails(user)),
    updateUser: (user) => dispatch(userMasterActions.updateUser(user)),
    inActiveRow: (user, isActive) => dispatch(userMasterActions.inActiveRow(user, isActive)),
    onHideShow: (isbool) => dispatch(userMasterActions.onHideShow(isbool)),
    onHideShowIsActive: (isbool) => dispatch(userMasterActions.onHideShowIsActive(isbool)),
    getRoleDDL: (data) => dispatch(userMasterActions.getRoleDDL(data)),
    getWDDL: (data) => dispatch(userMasterActions.getWDDL(data)),
    getSDDL: (data) => dispatch(userMasterActions.getSDDL(data)),
    getRDDL: (data) => dispatch(userMasterActions.getRDDL(data)),
    getASMDDL: (data) => dispatch(userMasterActions.getASMDDL(data)),
    getGDDL: (data) => dispatch(userMasterActions.getGDDL(data)),
    getDistrictDDL: (data) => dispatch(userMasterActions.getDistrictDDL(data)),
    getCityDDL: (data) => dispatch(userMasterActions.getCityDDL(data)),
    loadingData: (isLoding) => dispatch(userMasterActions.loadingData(isLoding)),
    exportData: (obj) => dispatch(userMasterActions.exportData(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(userMaster);